module.exports = __webpack_public_path__ + "files/0960d2f75f380942425c0d5854b1d1b9.svg";